module.exports = __webpack_public_path__ + "img/rknT2.1363cd3b.jpeg";